export default __webpack_public_path__ + "static/char-s-37-zh-Hant-d17ce03b066241f93c5b801416d8609d.png";